export default __webpack_public_path__ + "static/media/prestashop.729163fd.svg";